import { Box, TextField, Button } from "@material-ui/core";
import React from "react";
import GridWrapper from "@components/elements/GridWrapper";
import { useForm } from "react-hook-form";
import TextFieldWrapper from "@components/wrappers/field/text";
import PasswordFieldWrapper from "@components/wrappers/field/password";

type FormValues = {
  email: string;
  password: string;
};

interface Props {
  lockedEmail?: string;
  onSubmit: (data: FormValues) => void;
}

export default function AccountForm(props: Props): JSX.Element {
  const { lockedEmail = "" } = props;

  const defaultValues: FormValues = { email: lockedEmail, password: "" };
  const { control, handleSubmit } = useForm<FormValues>({ defaultValues });

  const onSubmit = (data: FormValues) => {
    return props.onSubmit(data);
  };

  return (
    <GridWrapper spacing={2}>
      <TextFieldWrapper
        control={control}
        name="email"
        textFieldProps={{
          label: "Email",
          variant: "filled",
          color: "secondary",
          InputProps: { readOnly: !!lockedEmail },
        }}
      />

      <PasswordFieldWrapper
        control={control}
        name="password"
        textFieldProps={{
          label: "Password",
          variant: "filled",
          color: "secondary",
        }}
      />

      <Button
        fullWidth
        size="large"
        variant="contained"
        color="secondary"
        onClick={handleSubmit(onSubmit)}
      >
        Create Account
      </Button>
    </GridWrapper>
  );
}
